export default __webpack_public_path__ + "fonts/zombie-properties.svg";